import FullScreenCard from '../../shared/FullScreenCard';
import GeneralContext from '../../../context/GeneralContext';
import { useContext, useEffect, useState } from 'react';
import { fetchGet, fetchBody } from '../../../utils/fetch';
import Table from '../../shared/Table';

function BenefitList() {

    const {
        changeModalTitle,
        changeModalType,
        changeModalText,
        changeModalFunction1,
        changeCurrentMenu,
        setBenefitEditId,
        setBenefitEditTitle,
        setBenefitEditValue
    } = useContext(GeneralContext);

    const [headers, setHeaders] = useState([
        {id: 'header0', text: 'Alerta'}
    ]);

    const [currentBenefitList, setCurrentBenefitList] = useState([
        {id: '1a', fields: [
            {id: '0', text: 'Error conectándose al servidor'}
          ]
        }
    ]);

    const [tableType, setTableType] = useState('display');

    const prepareBenefitList = (list) => {
        setHeaders([
            {id: 'header0', text: 'Título'},
            {id: 'header1', text: 'Valor'}
        ]);
        const newList = [];
        for (let i = 0; i < list.length; i++) {
            const item = {
                id: list[i].id,
                fields: [
                    {id: '0', text: list[i].title},
                    {id: '1', text: list[i].value}
                ]
            }
            newList.push(item);
        }
        setCurrentBenefitList(newList);
        setTableType('actions');
    }

    useEffect(() => {
        const getUsersList = async () => {
            const response = await fetchGet('benefits/');
            if (response.success) {
                prepareBenefitList(response.list);
            }
        }
        getUsersList();
    }, []);

    const editBenefit = (id) => {
        setBenefitEditId(id);
        for (let i = 0; i < currentBenefitList.length; i++) {
            if (id === currentBenefitList[i].id) {
                setBenefitEditTitle(currentBenefitList[i].fields[0].text);
                setBenefitEditValue(currentBenefitList[i].fields[1].text);
            }
        }
        changeCurrentMenu('edit-benefit');
    }

    const deleteBenefit = (id) => {
        const modal = document.getElementById("myModal");
        changeModalFunction1(() => async () => {
            const fetchData = {
                benefitId: id
            }
            const response = await fetchBody('benefits/', 'DELETE', fetchData);
            if (response.success) {
                changeCurrentMenu('manage-benefits');
                modal.style.display = "none";
            } else {
                changeModalTitle('Error al intentar eliminar el beneficio');
                changeModalText(response.reason);
                changeModalType('alert');
                modal.style.display = "block";
            }
        })
        changeModalTitle('Eliminando beneficio');
        changeModalType('confirm');
        modal.style.display = "block";
    }

    const activeBenefitListActions = [
        {id: 0,
        text: 'Editar',
        buttonFunction: editBenefit},
        {id: 1,
        text: 'Eliminar',
        buttonFunction: deleteBenefit}
    ]

  return (
    <FullScreenCard hasBackNavigation={true} backNavigationFunction={changeCurrentMenu} backNavigationTarget={'manage-benefits'}>
        <h1>Listado de Beneficios</h1>
        <Table
            headers={headers}
            data={currentBenefitList}
            type={tableType}
            actions={activeBenefitListActions}
            actionsClass='doubleColumnAuto'
        />
    </FullScreenCard>
  )
}

export default BenefitList